import React, { useState, useEffect } from 'react'
import { Form, Input, Button, Row, Col, Select, Upload, Icon } from 'antd'
import { toast } from 'react-toastify'
import { UploadOutlined } from '@ant-design/icons'
import apiRequest from '../hooks/ApiRequest'

const EndorseForm = props => {
  const { form, onSuccess, policyId, visible, record } = props
  const [loading, setLoading] = useState(false)
  const [typeOptions, setTypeOptions] = useState([])
  const [fileUrl, setFileUrl] = useState('')
  const { Option } = Select

  const { getFieldDecorator, validateFields } = form


  const fetchEndorsementTypes = async () => {
    try {
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL}/Policy/GetAllEndorsementType/EndorsementsType`,
        'GET'
      )
      const result = res.data ? res.data : res

      if (result.success) {
        setTypeOptions(result.data)
      } else {
        toast.error(result.message || 'Failed to load endorsement types')
      }
    } catch (error) {
      toast.error('Error fetching endorsement types')
      console.error('Fetch endorsement error:', error)
    }
  }


  useEffect(() => {
    if (visible) {
      // fetchEndorsementTypes()
    }
  }, [visible])


  useEffect(() => {
    if (!visible) {
      form.resetFields()
      setFileUrl('')
    }
  }, [visible])


useEffect(() => {
  if (record) {
    form.setFieldsValue({
      typeOfChange: record.typeOfChangeId,
      note: record.data,
      // handle file if needed
    });
  }
}, [record]);



  const handleEndorsementAndSaveDocument = e => {
    e.preventDefault()
    form.validateFields(async (err, values) => {
      if (err) return
      setLoading(true);

      CreateEndorsement(
        values.file,
        values,
        policyId,
        setLoading,
        onSuccess,
        record 
      )
    })
  }

  return (
    <div className="container-box" style={{ marginTop: '15px' }}>
      <Form layout="vertical" onSubmit={handleEndorsementAndSaveDocument}>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Type of Change">
              {getFieldDecorator('typeOfChange', {
                rules: [{ required: true, message: 'Please select type of change' }],
              })(
                <Select
                  placeholder="Select type of change"
                  onFocus={fetchEndorsementTypes}
                >
                  {typeOptions.map(type => (
                    <Option key={type.id} value={type.id}>
                      {type.name}
                    </Option>
                  ))}
                </Select>

              )}
            </Form.Item>
          </Col>

          {/* File Upload */}
          <Col span={8}>
            <Form.Item label="Upload Document">
              {getFieldDecorator('file', {
                valuePropName: 'fileList', 
                getValueFromEvent: e => Array.isArray(e) ? e : e && e.fileList,
                rules: [{ required: true, message: 'Please upload a document' }],
              })(
                <Upload
                  beforeUpload={() => false}
                  showUploadList={true}
                >
                  <Button
                    icon={<UploadOutlined />}
                    style={{ height: '30px', minWidth: '150px' }}
                  >
                    Select File
                  </Button>
                </Upload>
              )}

            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label="Note">
              {getFieldDecorator('note', {
                rules: [{ required: true, message: 'Please enter a note' }],
              })(<Input.TextArea placeholder="Enter note" rows={1} />)}
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Submit Endorsement
          </Button>
        </Form.Item>
      </Form>
    </div>
  )


  async function FiletoFileBytes(file) {
    // debugger;
    try {
      let base64String = '';

      if (file) {
        const arrayBuffer = await file.arrayBuffer();
        const uint8Array = new Uint8Array(arrayBuffer);
        base64String = btoa(
          uint8Array.reduce((data, byte) => data + String.fromCharCode(byte), '')
        );

        return base64String;
      }
    } catch (error) {
      console.error('Error processing file:', error);
    }
  }

  async function UploadDocument(base64File) {
     debugger;
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_DOCUMENT}/Document`,
        'POST',
        {
          productId: 0,
          moduleId: 1,
          entityId: policyId,
          entityNumber: 'POL-2025-0001',
          documentMasterId: 10,
          insurerId: 'INS123',
          fileBytes: base64File,
          entityType: 'Policy',
        }
      );
      return response.data || response;
    } catch (error) {
      console.error('Error uploading document:', error);
      throw error;
    }
  }


  async function CreateEndorsement(file, values, policyId, setLoading, onSuccess) {
    try {
      setLoading(true);

      try {
        const fields = await form.validateFields()
        const uploadedFiles = form.getFieldValue('file')

        if (uploadedFiles && uploadedFiles.length > 0) {
          const selectedFile = uploadedFiles[0].originFileObj
          const base64File = await FiletoFileBytes(selectedFile)
          console.log('Base64 Converted File:', base64File)
          const uploadResult = await UploadDocument(base64File);
          console.log('Upload Result:', uploadResult);

          if (!uploadResult.success) {
            toast.error(uploadResult.error || 'Document upload failed');
            setLoading(false);
            return; 
          }

          // debugger;

          const effectivePolicyId = policyId || record?.policyId;

          const endorsementPayload = {
             Id: record?.id, 
            TypeOfChangeId: values.typeOfChange,
            PolicyId: effectivePolicyId,
            Data: values.note,
            DocumentUrl: uploadResult.data?.fileBytes || '',
            ApprovedBy: null,
            Comments: ''
          }

          console.log('Upload result:', uploadResult); 

          const endorsementRes = await apiRequest(
            `${process.env.REACT_APP_BASE_URL}/Policy/CreateEndorsement`,
            'POST',
            endorsementPayload
          );

          const result = endorsementRes.data || endorsementRes;

          if (!result.success) {
            toast.error(result.message || 'Endorsement creation failed');
          } else {
            toast.success('Endorsement created successfully');
          if (onSuccess) onSuccess(result.data); 
          }
        } else {
          toast.error('No file selected.')
        }
      } catch (err) {
        console.error('Validation/File error:', err)
      }



    } catch (error) {
      console.error('Error in CreateEndorsement:', error);
      toast.error('Something went wrong');
    } finally {
      setLoading(false);
    }
  }


}

export default Form.create()(EndorseForm)